export interface Material {
  id?: number;
  url: string;
  modified?: number;
}
export enum DownloadFileType {
  CSV = 'CSV',
  PDF = 'PDF',
  PPTX = 'PPTX',
  EXCEL = 'EXCEL',
  SPREADSHEET = 'SPREADSHEET',
  GOOGLE_SLIDE = 'GOOGLE_SLIDE'
}
export enum EXPORT_TYPE {
  PAGES = 'PAGES',
  ROWS = 'ROWS'
}
export enum CustomDownloadType {
  GG_SLIDE_HISTORY = 'GG_SLIDE_HISTORY',
  GOOGLE_DOCS_VIDEO = 'GOOGLE_DOCS_VIDEO',
  GOOGLE_DOCS_STATIC_POST = 'GOOGLE_DOCS_STATIC_POST'
}
